import { type TranslationTree } from '@/i18n/types';

export const messages = {
  impressions: 'Impressões',
  reach: 'Alcance',
  reachHint: 'pessoas diferentes',
  clicks: 'Cliques',
  ctr: 'CTR',
  leads: 'Contatos',
  leadsHint: 'aceitaram compartilhar',
  dismisses: 'Dispensas',
  dismissesHint: 'tocaram em "Agora não"',
  couponCopies: 'Cupons copiados',
  couponCopiesHint: 'vezes que o código foi copiado',
} satisfies TranslationTree;
